import request from '@/utils/request'

export function getTagList (data) {
  // get url, post json
  return request({
    url: '/api/v1/tags',
    method: 'POST',
    params: {
      data
    },
    data
  })
}

export function getListByKey (data, key) {
  // get url, post json
  return request({
    url: '/api/v1/tags/search/' + key,
    method: 'POST',
    data
  })
}

export function insertListById (data) {
  return request({
    url: '/api/v1/tags/insert',
    method: 'POST',
    data
  })
}

export function upsertListById (data) {
  return request({
    url: '/api/v1/tags/upsert',
    method: 'POST',
    data
  })
}
